import { ɵɵdefineInjectable, ɵɵinject, Injectable, Optional, Component, Input, Directive, Renderer2, ElementRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function IconSpriteComponent_ng_container_0__svg_title_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "title");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("id", ctx_r4.src.split("#")[1] + "-title");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.title);
} }
function IconSpriteComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg");
    ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_0__svg_title_2_Template, 2, 2, "title", 0);
    ɵngcc0.ɵɵelement(3, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r0.classes)("width", ctx_r0.width)("height", ctx_r0.height || ctx_r0.width);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.title && ctx_r0.src);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r0.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_1__svg_title_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "title");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("id", ctx_r5.src.split("#")[1] + "-title");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.title);
} }
function IconSpriteComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 1);
    ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_1__svg_title_2_Template, 2, 2, "title", 0);
    ɵngcc0.ɵɵelement(3, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attribute", ctx_r1.attribute);
    ɵngcc0.ɵɵattribute("class", ctx_r1.classes)("width", ctx_r1.width)("height", ctx_r1.height || ctx_r1.width);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.title && ctx_r1.src);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r1.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_2__svg_title_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "title");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("id", ctx_r6.src.split("#")[1] + "-title");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.title);
} }
function IconSpriteComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg");
    ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_2__svg_title_2_Template, 2, 2, "title", 0);
    ɵngcc0.ɵɵelement(3, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r2.classes)("width", ctx_r2.width)("height", ctx_r2.height || ctx_r2.width)("viewBox", ctx_r2.viewBox)("preserveAspectRatio", ctx_r2.preserveAspectRatio);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.title && ctx_r2.src);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r2.src, null, "xlink");
} }
function IconSpriteComponent_ng_container_3__svg_title_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "title");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("id", ctx_r7.src.split("#")[1] + "-title");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.title);
} }
function IconSpriteComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 1);
    ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_3__svg_title_2_Template, 2, 2, "title", 0);
    ɵngcc0.ɵɵelement(3, "use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attribute", ctx_r3.attribute);
    ɵngcc0.ɵɵattribute("class", ctx_r3.classes)("width", ctx_r3.width)("height", ctx_r3.height || ctx_r3.width)("viewBox", ctx_r3.viewBox)("preserveAspectRatio", ctx_r3.preserveAspectRatio);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.title && ctx_r3.src);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("href", ctx_r3.src, null, "xlink");
} }
class IconSpriteConfig {
}

/**
 * To access a global sprite path
 */
class IconSpriteService {
    constructor(config) {
        if (config) {
            this.setPath(config.path);
        }
    }
    setPath(path) {
        this.spritePath = path;
    }
    getPath() {
        return this.spritePath;
    }
}
IconSpriteService.ɵfac = function IconSpriteService_Factory(t) { return new (t || IconSpriteService)(ɵngcc0.ɵɵinject(IconSpriteConfig, 8)); };
/** @nocollapse */ IconSpriteService.ɵprov = ɵɵdefineInjectable({ factory: function IconSpriteService_Factory() { return new IconSpriteService(ɵɵinject(IconSpriteConfig, 8)); }, token: IconSpriteService, providedIn: "root" });
/** @nocollapse */
IconSpriteService.ctorParameters = () => [
    { type: IconSpriteConfig, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: IconSpriteConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class IconSpriteComponent {
    constructor(iconSpriteService) {
        this.iconSpriteService = iconSpriteService;
        this.classes = 'icon';
        this.width = '100%';
        this.preserveAspectRatio = 'xMinYMax meet';
    }
    ngOnChanges(changes) {
        // If the src does not contain a # and a spritePath is set via the service, concatenate them
        if (this.src && !this.src.includes('#') && this.iconSpriteService.spritePath) {
            this.src = `${this.iconSpriteService.getPath()}#${this.src}`;
        }
    }
}
IconSpriteComponent.ɵfac = function IconSpriteComponent_Factory(t) { return new (t || IconSpriteComponent)(ɵngcc0.ɵɵdirectiveInject(IconSpriteService)); };
IconSpriteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IconSpriteComponent, selectors: [["svg-icon-sprite"]], inputs: { classes: "classes", width: "width", preserveAspectRatio: "preserveAspectRatio", src: "src", height: "height", viewBox: "viewBox", attribute: "attribute", title: "title" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[4, "ngIf"], ["svgIconSpriteAttr", "", 3, "attribute"]], template: function IconSpriteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, IconSpriteComponent_ng_container_0_Template, 4, 5, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, IconSpriteComponent_ng_container_1_Template, 4, 6, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, IconSpriteComponent_ng_container_2_Template, 4, 7, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(3, IconSpriteComponent_ng_container_3_Template, 4, 8, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.viewBox && !ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.viewBox && ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewBox && !ctx.attribute);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewBox && ctx.attribute);
    } }, directives: function () { return [ɵngcc1.NgIf, IconSpriteDirective]; }, styles: ["[_nghost-%COMP%]   svg[_ngcontent-%COMP%], [_nghost-%COMP%]   use[_ngcontent-%COMP%]{fill:currentColor}"] });
/** @nocollapse */
IconSpriteComponent.ctorParameters = () => [
    { type: IconSpriteService }
];
IconSpriteComponent.propDecorators = {
    src: [{ type: Input }],
    classes: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    viewBox: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }],
    attribute: [{ type: Input }],
    title: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteComponent, [{
        type: Component,
        args: [{
                selector: 'svg-icon-sprite',
                template: "<ng-container *ngIf=\"!viewBox && !attribute\">\n  <svg [attr.class]=\"classes\"\n       [attr.width]=\"width\"\n       [attr.height]=\"height || width\">\n    <title *ngIf=\"title && src\" [attr.id]=\"src.split('#')[1] + '-title'\">{{title}}</title>\n    <use [attr.xlink:href]=\"src\"></use>\n  </svg>\n</ng-container>\n\n<ng-container *ngIf=\"!viewBox && attribute\">\n  <svg [attr.class]=\"classes\"\n       [attr.width]=\"width\"\n       [attr.height]=\"height || width\"\n       svgIconSpriteAttr [attribute]=\"attribute\">\n    <title *ngIf=\"title && src\" [attr.id]=\"src.split('#')[1] + '-title'\">{{title}}</title>\n    <use [attr.xlink:href]=\"src\"></use>\n  </svg>\n</ng-container>\n\n<ng-container *ngIf=\"viewBox && !attribute\">\n  <svg [attr.class]=\"classes\"\n       [attr.width]=\"width\"\n       [attr.height]=\"height || width\"\n       [attr.viewBox]=\"viewBox\"\n       [attr.preserveAspectRatio]=\"preserveAspectRatio\">\n    <title *ngIf=\"title && src\" [attr.id]=\"src.split('#')[1] + '-title'\">{{title}}</title>\n    <use [attr.xlink:href]=\"src\"></use>\n  </svg>\n</ng-container>\n\n<ng-container *ngIf=\"viewBox && attribute\">\n  <svg [attr.class]=\"classes\"\n       [attr.width]=\"width\"\n       [attr.height]=\"height || width\"\n       [attr.viewBox]=\"viewBox\"\n       [attr.preserveAspectRatio]=\"preserveAspectRatio\"\n       svgIconSpriteAttr [attribute]=\"attribute\">\n    <title *ngIf=\"title && src\" [attr.id]=\"src.split('#')[1] + '-title'\">{{title}}</title>\n    <use [attr.xlink:href]=\"src\"></use>\n  </svg>\n</ng-container>\n",
                styles: [":host svg,:host use{fill:currentColor}"]
            }]
    }], function () { return [{ type: IconSpriteService }]; }, { classes: [{
            type: Input
        }], width: [{
            type: Input
        }], preserveAspectRatio: [{
            type: Input
        }], src: [{
            type: Input
        }], height: [{
            type: Input
        }], viewBox: [{
            type: Input
        }], attribute: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

/**
 * Set your own attribute key/value pairs on the generated SVG element, i.e. focusable="false"
 */
class IconSpriteDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
    }
    ngOnInit() {
        if (Array.isArray(this.attribute[0])) {
            const attributeArr = this.attribute;
            attributeArr.forEach((obj) => {
                this.renderer.setAttribute(this.el.nativeElement, obj[0], obj[1] ? obj[1] : '');
            });
        }
        else {
            const attribute = this.attribute;
            if (attribute[0]) {
                this.renderer.setAttribute(this.el.nativeElement, attribute[0], attribute[1] ? attribute[1] : '');
            }
        }
    }
}
IconSpriteDirective.ɵfac = function IconSpriteDirective_Factory(t) { return new (t || IconSpriteDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IconSpriteDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: IconSpriteDirective, selectors: [["", "svgIconSpriteAttr", ""]], inputs: { attribute: "attribute" } });
/** @nocollapse */
IconSpriteDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
IconSpriteDirective.propDecorators = {
    attribute: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteDirective, [{
        type: Directive,
        args: [{
                selector: '[svgIconSpriteAttr]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { attribute: [{
            type: Input
        }] }); })();

/**
 * Using forRoot({ path: 'filepath' }), this module can be provided as a
 * singleton for the global application (including lazy loaded submodules).
 */
class IconSpriteModule {
    static forRoot(config) {
        return {
            ngModule: IconSpriteModule,
            providers: [
                { provide: IconSpriteConfig, useValue: config }
            ]
        };
    }
}
IconSpriteModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: IconSpriteModule });
IconSpriteModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function IconSpriteModule_Factory(t) { return new (t || IconSpriteModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconSpriteModule, { declarations: function () { return [IconSpriteComponent, IconSpriteDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconSpriteComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconSpriteModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    IconSpriteComponent,
                    IconSpriteDirective
                ],
                exports: [IconSpriteComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of icon-sprite
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IconSpriteComponent, IconSpriteConfig, IconSpriteModule, IconSpriteService, IconSpriteDirective as ɵa };

//# sourceMappingURL=ng-svg-icon-sprite.js.map